import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { BiTrash } from "react-icons/bi";
import { VscDiffAdded } from "react-icons/vsc";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import Swal from "sweetalert2";
import { viewImage } from "../CommonUtils/viewImage";
import { BsEyeFill } from "react-icons/bs";
import { useDispatch } from "react-redux";
import * as Yup from 'yup';
import * as bie from "react-bootstrap";
import { ERROR_MSG } from "../CommonUtils/contextVariables";
import { ImagePdfBucket } from "../CommonUtils/ImagesBase64";
import { FaEye } from "react-icons/fa";
import { failureAlert } from "../CommonUtils/SweetAlerts";
import CommonFormHeading from "../CommonUtils/CommonFormHeading";
export default function AffiliationUploads() {
    const dispatch = useDispatch();
    const acYear = sessionStorage.getItem('ac_year');
    const [docType, setDocType] = useState([]);
    const hasFetchedData = useRef(false);
    const [data, setData] = useState([]);
    const AfflUploadValidaton = Yup.object({
        uploads: Yup.array().of(Yup.object().shape({
            docDescription: Yup.string().required(ERROR_MSG).nullable(),
            docUploading: Yup.string().required(ERROR_MSG).nullable(),
            documentType: Yup.string().required(ERROR_MSG).nullable(),
            docUploadingDate: Yup.string().required(ERROR_MSG)
        })),
    })
    const formik = useFormik({
        initialValues: {
            uploads: [{
                docDescription: '',
                docUploading: '',
                documentType: '',
                docUploadingDate: ''
            }]
        },
        validationSchema: AfflUploadValidaton,
        onSubmit: (val) => {
            Swal.fire({
                title: "Are you sure want to submit the data?",
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "Submit",
                cancelButtonText: "Cancel",
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.API_URL + `OamdcUploads `
                    CommonAxiosPost(url, val?.uploads, dispatch).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire(res?.data?.sdesc, '', 'success').then((res) => {
                                if (res?.isConfirmed) {
                                    window.location.reload()
                                }
                            })
                        }
                        else {
                            failureAlert("Failed to submit")

                        }
                    })
                }
            });

        }
    })
    async function GetDocType() {
        try {
            const url = `${config.url.API_URL}getuploadlist`;
            const res = await CommonAxiosGet(url, dispatch);
            if (res?.data?.scode === '01') {
                setDocType(res?.data?.uploadlist);
            } else {
                setDocType([]);
            }
        } catch (error) {
            console.error('Error fetching upload list:', error);
            setDocType([]);
        }

        try {
            const urll = `${config.url.API_URL}getuploads`;
            const res2 = await CommonAxiosGet(urll, dispatch);

            if (res2?.data?.scode === '01') {
                setData(res2?.data?.getuploads);

                const formatDate = (dateStr) => {
                    if (!dateStr) return '';
                    const parts = dateStr.split('/');
                    if (parts.length !== 3) return '';
                    const [day, month, year] = parts;
                    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                };

                const areaDetails = res2?.data?.getuploads.length > 0
                    ? res2?.data?.getuploads.map((up) => ({
                        docDescription: up?.doc_descrption || '',
                        docUploading: up?.doc_uploading || '',
                        documentType: up?.document_type || '',
                        docUploadingDate: formatDate(up?.doc_uploading_date) || '',
                    }))
                    : [{
                        docDescription: '',
                        docUploading: '',
                        documentType: '',
                        docUploadingDate: ''
                    }];

                formik.setFieldValue('uploads', areaDetails);
            } else {
                setData([]);
                formik.setFieldValue('uploads', [{
                    docDescription: '',
                    docUploading: '',
                    documentType: '',
                    docUploadingDate: ''
                }]);
            }
        } catch (error) {
            console.error('Error fetching uploads:', error);
            setData([]);
            formik.setFieldValue('uploads', [{
                docDescription: '',
                docUploading: '',
                documentType: '',
                docUploadingDate: ''
            }]);
        }
    }

    function DeleteReport(sl_no) {
        Swal.fire({
            title: "Are you sure want to delete the data?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
            backdrop: false,
        }).then((result) => {
            if (result.isConfirmed) {
                const deleteAffilUploadvalues = { slno: sl_no }
                let url = config.url.API_URL + `deleteUploads`
                CommonAxiosPost(url, deleteAffilUploadvalues, dispatch).then(res => {
                    if (res?.data?.scode === "01") {
                        Swal.fire(res?.data?.sdesc, "Success", "success").then((refresh) => {
                            if (refresh.isConfirmed) {
                                GetDocType()
                            }
                        });
                    } else {
                        failureAlert("Something went wrong,Please check");
                    }
                });
            }
        });
    }


    useEffect(() => {
        if (!hasFetchedData.current) {
            GetDocType()
            hasFetchedData.current = true
        }
    }, [])
    return (
        <>
            <bie.Container fluid className="px-1 affl-newdiv" >
                <CommonFormHeading heading={`Upload documents ${acYear}`} />

                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <div className="inner-herbpage-service-title-sub pt-0 mb-3"  >
                        <h1 className="">Document Uploads</h1>
                    </div>
                    <FormikProvider value={formik}>
                        <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="form_adjust" >
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Document Type</th>
                                            <th>Document Description</th>
                                            <th>Document Date</th>
                                            <th>Upload Document</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ textAlign: "center" }}>
                                        <FieldArray name="uploads">
                                            {({ push, remove }) => {
                                                return (
                                                    <>
                                                        {formik?.values?.uploads?.map((detail, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <center>{index + 1}</center>
                                                                </td>
                                                                <td>
                                                                    <Field as="select" className="form-control mt-0" name={`uploads[${index}].documentType`}>
                                                                        <option value=''>--Select--</option>
                                                                        {docType && docType.map((dd, i) => (
                                                                            <option value={dd?.upload_id} key={i}>{dd?.name}</option>
                                                                        ))}
                                                                    </Field>
                                                                    <ErrorMessage name={`uploads[${index}].documentType`} component="div" className="text-error" />
                                                                </td>
                                                                <td>
                                                                    <Field type="textarea" className="form-control mt-0" name={`uploads[${index}].docDescription`} maxLength="300" />
                                                                    <ErrorMessage name={`uploads[${index}].docDescription`} component="div" className="text-error" />
                                                                </td>
                                                                <td>
                                                                    <Field
                                                                        type="date" onKeyDown={(e) => { e.preventDefault() }}
                                                                        className="form-control mt-0"
                                                                        name={`uploads[${index}].docUploadingDate`}
                                                                        style={{ width: "10rem" }}
                                                                        min="1970-01-01"
                                                                        max={new Date().toISOString().split('T')[0]}
                                                                    />
                                                                    <ErrorMessage name={`uploads[${index}].docUploadingDate`} component="div" className="text-error" />
                                                                </td>
                                                                <td>
                                                                    <bie.Row className="align-items-center">
                                                                        <bie.Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10} >
                                                                            <input type="file" className="form-control" name={`uploads[${index}].docUploading`} accept="application/pdf"
                                                                                onChange={(e) => {
                                                                                    let filename = `uploads_docUploading`
                                                                                    let path = "/Uploads/AffiliationPDFs/2024/UploadDocuments/"
                                                                                    ImagePdfBucket(e, formik, path, `uploads[${index}].docUploading`, filename, "pdf")

                                                                                }}
                                                                            />
                                                                        </bie.Col>
                                                                        <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} >

                                                                            {formik?.values?.uploads[index]?.docUploading && <button type='button' className='btn btn-primary' onClick={() => { viewImage(formik?.values?.uploads[index]?.docUploading) }}> <FaEye size={20} /> </button>}
                                                                        </bie.Col>
                                                                        <ErrorMessage name={`uploads[${index}].docUploading`} component="div" className="text-error" />
                                                                    </bie.Row>
                                                                </td>
                                                                <td align="center">
                                                                    {index === 0 && (
                                                                        <button
                                                                            type="button"
                                                                            className="button-title btn btn-sm btn-success"
                                                                            onClick={() => {
                                                                                push({
                                                                                    documentType: '',
                                                                                    docDescription: '',
                                                                                    docUploadingDate: '',
                                                                                    docUploading: '',

                                                                                });
                                                                            }}
                                                                        >
                                                                            <VscDiffAdded />
                                                                        </button>
                                                                    )}
                                                                    {index >= 1 && (
                                                                        <button type="button" className="button-title btn btn-sm btn-danger"
                                                                            onClick={() => {
                                                                                remove(index);
                                                                            }}
                                                                        >
                                                                            <BiTrash />
                                                                        </button>
                                                                    )}
                                                                </td>
                                                            </tr >
                                                        ))}
                                                    </>
                                                );
                                            }}
                                        </FieldArray>

                                    </tbody>
                                </table>
                            </div>
                            <div className="d-grid gap-2 button-end">
                                <button type='submit' className='btn btn-success btn-sm float-end mt-2 mb-4'>Submit</button>
                            </div>
                        </Form>
                    </FormikProvider >
                    {data?.length > 0 ? <>
                        <div className="inner-herbpage-service-title-sub pt-0 mb-3"  >
                            <h1>Document Uploads Detailed Report</h1>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Document Type</th>
                                        <th>Document Description</th>
                                        <th>Document Date</th>
                                        <th>View Document</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody style={{ textAlign: "center" }}>
                                    {data && data?.map((dd, i) => (
                                        <tr>
                                            <td>{i + 1}</td>
                                            <td className="text-left">{dd?.doc_name}</td>
                                            <td className="text-left">{dd?.doc_descrption}</td>
                                            <td>{dd?.doc_uploading_date}</td>
                                            <td>{<button type='button' onClick={() => viewImage(dd?.doc_uploading)} className='btn btn-primary'><BsEyeFill size={20}></BsEyeFill></button>}</td>
                                            <td className="d-flex justify-content-center">
                                                <bie.Button
                                                    type="button" className="btn btn-danger  btn-sm    text-center"
                                                    onClick={() => { DeleteReport(dd.sno); }}><BiTrash />
                                                </bie.Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div></> : null}
                </bie.Container>
            </bie.Container>
        </>
    )
}